// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clip-preview-container {
    height: 100%;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ClipMaker/css/ClipPreview.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf","sourcesContent":[".clip-preview-container {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
